import { render, staticRenderFns } from "./ResidentInfo.vue?vue&type=template&id=75e9af1a&scoped=true&"
import script from "./ResidentInfo.vue?vue&type=script&lang=js&"
export * from "./ResidentInfo.vue?vue&type=script&lang=js&"
import style0 from "./ResidentInfo.vue?vue&type=style&index=0&id=75e9af1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e9af1a",
  null
  
)

export default component.exports